import request from "@/utils/request";

export default function adminOpenHiddenMessage(id, hiddenMessage) {
    return request({
        url: `/newsMessage/agencyOpenHiddenMessage/`+id+`/`+hiddenMessage,
        method: 'get',
    })
}
